export const queryLoginState = "/portal/login/with/token";
